import "angular";
import "angular-resource";
import "angular-animate";
import "angular-cookies";
import "angular-messages";
import "angular-sanitize";
(() => {
    window["taTools"] = {};
    window["rangy"] = require('rangy/lib/rangy-core');
})();
require('rangy/lib/rangy-selectionsaverestore');
require('textangularJs/dist/textAngular-sanitize');
require('textAngularJs/dist/textAngularSetup');
require('textAngularJs/dist/textAngular');
import "moment";
import "jquery";
import "bootstrap";
import "lodash";
import "jquery.cookie";
import "nprogress";
import "urijs";
import "urijs/src/URITemplate";
import "uuid";
import "d3";
import "flot/jquery.flot";
import "flot/jquery.flot.pie";
import "flot/jquery.flot.stack";
import "flot/jquery.flot.time";
import "favico.js";
import "angular-ui-bootstrap";
import "angular-native-dragdrop";
import "angular-vs-repeat";
import "ng-sortable";
require("../../js/scotchPanels");
require("gritter/js/jquery.gritter");
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui/ui/widgets/draggable";
import "jquery-ui/ui/widgets/droppable";
import "jquery.fancytree";
import 'jquery.fancytree/dist/modules/jquery.fancytree.filter';
import 'angular-bootstrap-colorpicker/js/bootstrap-colorpicker-module.js';

